/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import {
  FETCHED_PARTICIPANT_STATUSES,
  PUBLISH_STUDY_GID,
  FETCHING_PARTICIPANTS,
  RECEIVE_PARTICIPANTS,
  ERROR_PARTICIPANTS,
  PUBLISH_PARTICIPANTS_FILTER,
  RESET_PARTICIPANTS_FILTER
} from '../actions/actionTypes';

const participantsState = {
  studyGid: null,
  isFetching: false,
  items: null,
  error: null,
  participantStatuses: null,
  participantsFilter: {
    status: '',
    organization: '',
    optionalDocPublished: ''
  }
};

const participantReducer = (state = participantsState, action) => {
  switch (action.type) {
    case FETCHING_PARTICIPANTS:
      return Object.assign({}, state, { isFetching: true });
    case RECEIVE_PARTICIPANTS:
      return Object.assign({}, state, { isFetching: false, items: action.payload, error: null });
    case ERROR_PARTICIPANTS:
      return Object.assign({}, state, { isFetching: false, error: action.error, items: [] });
    case PUBLISH_STUDY_GID:
      return Object.assign({}, state, { studyGid: action.payload });
    case FETCHED_PARTICIPANT_STATUSES:
      return Object.assign({}, state, { participantStatuses: action.payload });
    case PUBLISH_PARTICIPANTS_FILTER:
      return Object.assign({}, state, {
        participantsFilter: {
          status: action.payload.status,
          organization: action.payload.organization,
          optionalDocPublished: action.payload.optionalDocPublished
        }
      });
    case RESET_PARTICIPANTS_FILTER:
      return Object.assign({}, state, {
        participantsFilter: { status: '', organization: '', optionalDocPublished: '' }
      });
    default:
      return state;
  }
};

export default participantReducer;
